/**
 * Set a cookie that can be shared across all subdomains
 * @param name - Cookie name
 * @param value - Cookie value
 * @param days - Number of days until expiration (default: 365)
 */
export const setCrossSubdomainCookie = (
  name: string,
  value: string,
  days: number = 365,
): void => {
  const domain = window.location.hostname.split('.').slice(-2).join('.');

  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${name}=${value}; ${expires}; domain=.${domain}; path=/; SameSite=Lax; Secure`;
};

/**
 * Get cookie value by name
 * @param name - Cookie name
 * @returns Cookie value or null
 */
export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }

  return null;
};

/**
 * Delete a cookie across all subdomains
 * @param name - Cookie name
 */
export const deleteCrossSubdomainCookie = (name: string): void => {
  const domain = window.location.hostname.split('.').slice(-2).join('.');

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${domain}; path=/;`;
};

/**
 * Get user data from cross-subdomain cookie
 * @returns Parsed user data object or null
 */
export const getUserDataFromCookie = <T = unknown>(): T | null => {
  const userDataString = getCookie('userData');

  if (!userDataString) {
    return null;
  }

  try {
    return JSON.parse(userDataString) as T;
  } catch (error) {
    console.error('Failed to parse user data from cookie:', error);
    return null;
  }
};
